// extracted by mini-css-extract-plugin
module.exports = {"addRoleWrp":"chooseRole_addRoleWrp__1lZI1","optionWrp":"chooseRole_optionWrp__3OV9d","text":"chooseRole_text__xep2d"};